import DashboardProfile from './DashboardProfile';
import ProfileHeader from './ProfileHeader';
import NotesPanel from './NotesPanel';
import DashboardProfileV2 from './DashboardProfileV2';
export { DashboardProfile, ProfileHeader, NotesPanel, DashboardProfileV2 };



// WEBPACK FOOTER //
// ./src/features/dashboard/containers/index.js